import Cookies from 'js-cookie'
import  getTopPersonalization from './_getTopPeronsalization';
const pointValueBuy = 20;
const pointValueWL = 12;
const pointValueBag = 6;
const pointValueView = 1;
//   var supersToDoSizeTracking = ['410', '430', '425', '480', '445'];
    // NOT THESE: [420,435,450,440,470]
const getPersonalizationObject = (localStorageName, defaultValue = {}) => {
    const stringValue = localStorage.getItem(localStorageName) || JSON.stringify(defaultValue);
    let pointsForCat = defaultValue
    try{
        pointsForCat = JSON.parse(stringValue)
    } catch(parseError){
        console.log(`error parsing ${stringValue} into JSON, removing ${localStorageName}`)
        localStorage.removeItem(localStorageName)
    }
    return pointsForCat
}
const addToWLPersonalizationTracking = () => {
    personalizationTracking(pointValueWL);
};
const addToBagPersonalizationTracking = () => {
    personalizationTracking(pointValueBag);
};
const viewProductPersonalizationTracking = () => {
    migrateCookiesToStorage();
    personalizationTracking(pointValueView);
};
  
const migrateCookiesToStorage = () => {
    $.removeCookie("orderPzMf", {
        path: '/'
    });
    $.removeCookie("orderPzmfName", {
        path: '/'
    });
    $.removeCookie("orderPzdm", {
        path: '/'
    });
};
  
const personalizationTracking = (pointValue) => {
    Cookies.remove('preferredSplash')
    
    const parentToLookForPersonalizationInfo = $(".quickview-image").length > 0? $(".modal-body"): $("body");
    const categoryToPersonalizeDiv = parentToLookForPersonalizationInfo.find(".personalizationsuperforpoints")
    if (categoryToPersonalizeDiv.length > 0) {
        const categoryIdToAddPointsTo = categoryToPersonalizeDiv.eq(0).html();
        if (parentToLookForPersonalizationInfo.find(".personalizationbrand").length > 0) {
            const brandName = parentToLookForPersonalizationInfo.find(".personalizationbrand").eq(0).html();
            updatePersonalizationPoints(categoryIdToAddPointsTo, brandName, pointValue);
        }
    }
    const aYearFromNow = new Date();
    aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
    const topPersonalizationInfo = getTopPersonalization('ALL');
    if(topPersonalizationInfo.favoriteSuperCat == '445'){
        Cookies.set('preferredSplash', '/c/men?splashRedirect=true', {
            path: '/',
            expires: aYearFromNow
        });
    }else if(topPersonalizationInfo.favoriteSuperCat == '430'){
        Cookies.set('preferredSplash', '/c/juniors?splashRedirect=true', {
            path: '/',
            expires: aYearFromNow
        });
    }
};
  
const updatePersonalizationPoints = (categoryIdToTrack, key, count) => {
    const localStorageNameForCat = `personalization${categoryIdToTrack}`
    const storedObj = getPersonalizationObject(localStorageNameForCat, {})
    storedObj[key] = storedObj[key]? storedObj[key] + count : count//If the brand is already tracked, add to existing points, else create the entry
    localStorage[localStorageNameForCat] = JSON.stringify(storedObj)
    try{
        const toSaveObj = getPersonalizationObject('personalizationToSave', {})
        //Set up the supercat if it doesnt exist
        if(!toSaveObj[categoryIdToTrack]){
            toSaveObj[categoryIdToTrack] = {brand:{}}
        }
        //if we dont have the brand the create it, otherwise add to its existing count
        if(!toSaveObj[categoryIdToTrack].brand[key]){
            toSaveObj[categoryIdToTrack].brand[key] = count
        } else {
            toSaveObj[categoryIdToTrack].brand[key] = toSaveObj[categoryIdToTrack].brand[key] + count
        }
        localStorage.setItem('personalizationToSave', JSON.stringify(toSaveObj))
    } catch(e){ 
        console.log(e)
    }
    savePersonalizationPointsToDatabaseIfThresholdMeet()
};
const savePersonalizationPointsToDatabaseIfThresholdMeet = () =>{
    const toSaveObj = getPersonalizationObject('personalizationToSave', {})
    const totalPointValue = Object.keys(toSaveObj).reduce((runningTotal, superCatObj)=>{
        Object.keys(toSaveObj[superCatObj]).forEach(type => {
            Object.values(toSaveObj[superCatObj][type]).forEach(pointValue => runningTotal+=pointValue)
        })
        return runningTotal
    }, 0)
    if(totalPointValue >= window?.personalizationPointsUpdateThreshold){
        savePersonalizationPointsToDatabase()
    }
}
const savePersonalizationPointsToDatabase = (rebuildLocalStoragePoints = true) =>{
    try{
        const emailAddress = Cookies.get('personalizationEmail')
        if(emailAddress){
            const toSaveObj = getPersonalizationObject('personalizationToSave', {})
            localStorage.removeItem('personalizationToSave')
            //remove all the old personalization categories so we can refresh them with the service's response
            window?.personalizationCategoryIds?.split('|')?.forEach(catgroupIdToTrackAs => {
                localStorage.removeItem(`personalization${catgroupIdToTrackAs}`)
                if(!rebuildLocalStoragePoints){
                    localStorage.removeItem(`myFavoritespersonalization${catgroupIdToTrackAs}`)
                }
            });
            if(emailAddress && Object.keys(toSaveObj).length > 0){
                $.ajax({
                    url: '/wcs/resources/store/301/personalization/points/add',
                    contentType: "application/json",
                    cache: false,
                    type: 'POST',
                    data: JSON.stringify({emailAddress, points: toSaveObj}),
                    success: function (data) {
                        try{
                            if(rebuildLocalStoragePoints){
                                const points = data?.response?.points
                                //loop over the points object passed in and rebuild the personalization categories based on that
                                Object.keys(points).forEach(catgroupId => {
                                    const brand = points[catgroupId]?.brand
                                    localStorage.setItem(`personalization${catgroupId}`, JSON.stringify(brand))
                                })
                            }
                        }catch(e){console.log(e)}
                    },
                });
            }
        }
    }catch(e){ 
        console.log(e)
    }
    return true;
}
  
const getPersonalizationMergeParameter = () => {
    var returnParameter = "";
    // if($(".localstorage").length > 0){
    //   returnParameter = "&personalization=";
    //   var superEntryPrefix = "personalizationdelta";
    //   $(superEntriesToLoop).each(function(){
    //     var thisSuperDelta = localStorage[superEntryPrefix + String(this)];
    //     if(typeof thisSuperDelta != "undefined" && typeof thisSuperDelta != "null"){
    //       if(returnParameter != "&personalization=") returnParameter += "~";
    //       returnParameter += String(this) + "|" + thisSuperDelta;
    //     }
    //   });
    // }
    // if(returnParameter == "&personalization=") returnParameter = "";
    return returnParameter;
};
  
const afterAddToBagPersonalizationTracking = () => {
    // if($(".localstorage").length > 0){
    //   var superEntryPrefix = "personalizationdelta";
    //   var addToBagTrackingPrefix = "personalizationadd";
    //   var localStoragePrefix = "personalization";
    //   $(superEntriesToLoop).each(function(){
    //     var testSelector = $("." + addToBagTrackingPrefix + String(this));
    //     if(testSelector.length > 0){
    //       localStorage.removeItem(superEntryPrefix + String(this));
    //       localStorage[localStoragePrefix + String(this)] = testSelector.html();
    //     }
    //   });
    // }
};
  
const orderCompletePersonalizationTracking = () => {
    if ($(".localstorage").length > 0 && String(window.location).indexOf("/OrderOKView") > -1) {
        if (typeof localStorage["personalizationlastorder"] == undefined || localStorage["personalizationlastorder"] != $("#orderId").text()) {
            localStorage["personalizationlastorder"] = $("#orderId").text();
            $(".personalizationbuy").each(function() {
                const brandNameToTrack = $(this).data("personalizationmf");
                const categoryToTrack = String($(this).data("personalizationsuper"))?.split('|')[0]
                if (categoryToTrack.length > 0 && brandNameToTrack.length > 0 && window?.personalizationCategoryIds?.includes(categoryToTrack)) 
                    updatePersonalizationPoints(categoryToTrack, brandNameToTrack, pointValueBuy);
            });
        }
    }
};
  
const selectOnChangePersonalization = () => {
    if(window.superCat && $(".sessionstorage").length > 0){
        var desktopOrderBy = $('#desktopOrderBy').val();
        if(desktopOrderBy == "1"){
            sessionStorage.setItem("sesPz" + window.superCat, "");
        }
        if(desktopOrderBy == "0"){
            sessionStorage.setItem("sesPz" + window.superCat, sessionStorage.getItem("oldSesPz" + window.superCat));
        }
    }
};

const personalizationInit = () => {
    if(Cookies.get('personalizationInit')){
        const emailAddress = Cookies.get('personalizationEmail')
        Cookies.remove('personalizationInit');
		Cookies.remove('personalizationInit', { path: '/', domain: '.' + window.location.hostname });
        $.ajax({
            url: '/wcs/resources/store/301/personalization/points/get',
            contentType: "application/json",
            cache: false,
            type: 'POST',
            data: JSON.stringify({emailAddress}),
            success: function (data) {
                try{
                    const points = data?.response?.points
                    //loop over the points object passed in and merge them into the existing personalization points
                    Object.keys(points).forEach(catgroupId => {
                        const localStorageNameForCat = `personalization${catgroupId}`
                        const storedObj = getPersonalizationObject(localStorageNameForCat, {})

                        Object.keys(points[catgroupId]?.brand).forEach(brandName=> {
                            const storedPoints = points[catgroupId]?.brand[brandName]
                            storedObj[brandName] = storedObj[brandName]? storedObj[brandName] + storedPoints : storedPoints//If the brand is already tracked, add to existing points, else create the entry
                        })
                        localStorage[localStorageNameForCat] = JSON.stringify(storedObj)
                    })
                    //If we updated personalization from the logged in user, then clear the sesPZ so we can rebuild the emphasize parameter
                    window?.personalizationCategoryIds?.split('|')?.forEach(catgroupIdToTrackAs => {
                        sessionStorage.removeItem(`sesPz${catgroupIdToTrackAs}`)
                    });
                }catch(e){console.log(e)}
            },
        });
    }
}
  
export {
    addToWLPersonalizationTracking,
    addToBagPersonalizationTracking,
    viewProductPersonalizationTracking,
    getPersonalizationMergeParameter,
    afterAddToBagPersonalizationTracking,
    orderCompletePersonalizationTracking,
    selectOnChangePersonalization,
    savePersonalizationPointsToDatabase,
    personalizationInit
};